import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { getCurrencySymbol } from '../../utils/currency';
export function PriceFormatter({ currency, children }) {
    if (!currency) {
        return null;
    }
    return (_jsxs(Fragment, { children: [getCurrencySymbol(currency), (children / 100).toFixed(2)] }));
}
